export default (value) => {
  if (!value.length) return true;
  return (
    /^https:\/\/www\.linkedin\.com\//.test(value) ||
    /^https:\/\/linkedin\.com\//.test(value)
  );
};
